import { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, FormControlLabel, makeStyles, Checkbox, Radio, ButtonBase } from '@material-ui/core';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import DiaLog from '../../../../../components/Dialog';
import { AutoCompleteSelect } from '../../../../../components';
import { i18n } from '../../../../../language';
import AutoCompleteMultiCheckbox from '../../../../../components/AutoCompleteMultiCheckbox';
import { systemAPI } from '../../../../../apis';
import LongRemark from '../../../../../components/LongRemark';
import Text from '../../../../../components/Text';
import { DropRightIcon } from '../../../../../components/Icon';
import StyleInput from '../../../../../components/StyleInput';
import RecipientsListPopup from '../SatelliteStore/RecipientsListPopup';
import SatelliteStorePopup from '../SatelliteStore/SatelliteStorePopup';
import Counter from '../Field/Counter';
import useGetAdsList from '../../../../../utils/hooks/list/useGetAdsList';
import { getUUID } from '../../../../../utils';
import useUpdateEffect from '../../../../../utils/useUpdateEffect';
import { CentralStoreEmailAlert } from '../EmailAlert';
import CentralStoreThresholdPopup from '../SatelliteStore/CentralStoreThresholdPopup';

const useStyles = makeStyles((theme) => ({
  inputBase: {
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    height: '3.5rem',
    width: '24.5rem',
    padding: '0 1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  title: {
    fontSize: '0.875rem',
    fontWeight: '500',
    marginBottom: '0.625rem',
    color: '#7d86a9',
  },
  bgBorder: {
    borderTop: '0.5rem solid #f1f6ff',
  },
  colorRed: {
    color: '#ff0300',
  },
  checkBox: {
    marginRight: '0',
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  returnOrderTypeCheckBox: {
    marginRight: '0',
    '& .MuiRadio-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
      width: '9rem',
    },
    '& .Mui-checked': {
      color: '#538fff',
    },
  },
  radio: {
    borderColor: '#e4e7eb',
  },

  radioLabel: {
    flexBasis: '37%',
    '& .MuiRadio-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontWeight: '500',
      color: '#2e4469',
      fontSize: '1rem',
    },
    '& .Mui-checked': {
      color: '#538fff',
    },
  },
}));
const EquipmentCategoryDialog = ({ dialogFinishHandler, dialogCloseHandler }) => {
  const classes = useStyles();
  const loginInfo = useSelector((state) => state.loginInfo);
  // Immedlate=====》NONURGENT（4）
  // Emergency====》URGENT（2）
  const [returnOrderTypeList, setReturnOrderTypeList] = useState([
    { id: 4, label: i18n.t('SETTING_EQUIPMENT_NON_URGENT'), checked: false, isShowInput: false },
    { id: 2, label: i18n.t('SETTING_EQUIPMENT_URGENT'), checked: false, isShowInput: false },
    { id: null, label: i18n.t('SETTING_EQUIPMENT_THRESHOLD'), checked: false, isShowInput: true },
  ]);
  const [borrowOrderTypeList, setBorrowOrderTypeList] = useState([
    { id: 4, label: i18n.t('SETTING_EQUIPMENT_NON_URGENT'), checked: false },
    { id: 2, label: i18n.t('SETTING_EQUIPMENT_URGENT'), checked: false },
  ]);
  // 表单初始值
  const initAdsInfo = {
    adsBorrowServiceType: null,
    adsReturnServiceType: null,
    adsBorrowOrderType: null,
    adsReturnOrderType: null,
    adsReturnThresholdSettings: 1,
    adsBorrowEnableYn: 0,
    adsCreationTigger: 0,
    adsReturnEnableYn: 0,
    satelliteStoresTransferEnableYn: 0,
    satelliteStoresTransferServiceType: '',
  };
  const initFormData = {
    hospitalId: loginInfo.hospitalId,
    masterCategoryId: null,
    criticality: 1,
    loanModel: 1,
    wardIds: [],
    mainWardIds: null,
    checkboxState: false,
    checkboxADSIntergration: false,
    isReceiptConfirmation: 0,
    isWardTransfer: 0,
    satelliteStores: [],
    isPatientNo: 0,
    returnType: 1,
    returnDesignateLocation: '',
    returnDesignateRoom: '',
    emailAlertEnableYn: false,
    recipients: [],
    wardThreshold: [],
  };
  const [formData, setFormData] = useState(initFormData);
  const [criticalCategoryList] = useState([
    { text: i18n.t('SETTING_CRITICALITY_HIGH'), value: 2 },
    { text: i18n.t('SETTING_CRITICALITY_NORMAL'), value: 1 },
  ]);
  const [mainStoreList, setMainStoreList] = useState([]);
  const [wardIdsList, setWardIdsList] = useState();
  const [hospitalCode, setHospitalCode] = useState();
  const [equipmentCategoryList, setEquipmentCategoryList] = useState();
  const [showMainStore, setShowMainStore] = useState(false);
  const [thresholdSettingsReadOnly, setThresholdSettingsReadOnly] = useState(true);
  const [adsInfo, setAdsInfo] = useState(initAdsInfo);
  const [aDSServiceTypeList, setADSServiceTypeList] = useState();
  const [recipientsListPopup, setRecipientsListPopup] = useState(false);
  const [satelliteStorePopup, setSatelliteStorePopup] = useState(false);
  const [centralStoreThresholdPopup, setCentralStoreThresholdPopup] = useState(false);
  const [adsItemList] = useGetAdsList();
  const [loanDuration, setLoanDuration] = useState({
    loanDurationEnableYn: false,
    loanDuration: '',
  });
  const centralStore = formData?.loanModel === 1;
  const satelliteStores = formData?.loanModel === 2;
  const satelliteStoresTotal = formData?.satelliteStores?.length;

  // get wardIds List
  const getWardList = useCallback(async () => {
    try {
      const { result } = await systemAPI.getSysHospitalWardList({
        hospitalId: loginInfo.hospitalId,
        wardId: null,
      });
      setWardIdsList(result?.[0]?.wards);
      setHospitalCode(result?.[0]?.hospitalCode);
    } catch (error) {
      console.log(error);
    }
  }, [loginInfo]);
  // wards Options
  const wardsOptions = useMemo(() => {
    let wards = [];
    if (_.isArray(wardIdsList)) {
      wards = _.map(wardIdsList, (item) => ({ text: `${hospitalCode}-${item.wardName}`, value: item.wardId }));
    }
    return wards;
  }, [wardIdsList, hospitalCode]);

  // Equipment Category list api
  const euipmentMasterCategoryList = useCallback(async () => {
    try {
      const { result } = await systemAPI.getEquipmentMasterCategoryList();
      setEquipmentCategoryList(result);
    } catch (error) {
      console.log(error, 'error');
    }
  }, []);
  // Equipment Category list options
  const categoryList = useMemo(() => {
    let list = [];
    if (_.isArray(equipmentCategoryList)) {
      list = _.map(equipmentCategoryList, (item) => ({ text: item.masterCategoryName, value: item.masterCategoryId }));
    }
    return list;
  }, [equipmentCategoryList]);

  // get Ads Service Type  api
  const getAdsServiceTypeApi = useCallback(async () => {
    try {
      if (hospitalCode) {
        const { result } = await systemAPI.getAdsServiceType({ hospitalCode });
        setADSServiceTypeList(result.ADSInfoDetails);
      }
    } catch (error) {}
  }, [hospitalCode]);

  // Ads Service Type options
  const aDSServiceTypeListOptions = useMemo(() => {
    let list = [];
    if (_.isArray(aDSServiceTypeList)) {
      list = _.map(aDSServiceTypeList, (item, index) => ({ text: item.serviceDesc, value: item.serviceCid }));
    }
    return list;
  }, [aDSServiceTypeList]);

  const alignWardThresholdWithWardIds = useCallback((wardThreshold, wardIds) => {
    const thresholdWardIds = _.map(wardThreshold, (item) => item.wardId);

    // 删除 wardThreshold 中没有选择的 ward
    const cleanedThreshold = _.filter(wardThreshold, (wardItem) => _.includes(wardIds, wardItem.wardId));

    // satelliteStores 有但 wardThreshold 没有的就加上
    const missingWardIds = _.difference(wardIds, thresholdWardIds);
    const newWards = _.map(missingWardIds, (wardId) => ({
      wardId,
      alertUrgentThreshold: 0,
    }));
    return [...cleanedThreshold, ...newWards];
  }, []);

  const changeWardIds = (value) => {
    if (value.length >= 2) {
      setShowMainStore(true);
      setMainStoreList(value);
    }
    setShowMainStore(false);

    setFormData((preData) => ({ ...preData, wardIds: value }));
  };

  const changeLoanModel = (value) => {
    if (value === 1) {
      setFormData((preData) => ({
        ...preData,
        wardIds: _.uniqBy(
          _.map(
            preData.satelliteStores,
            (item) => _.find(wardsOptions, (wardItem) => wardItem.value === item.wardId) ?? { text: '', value: '' }
          ),
          'value'
        ),
        loanModel: value,
      }));
    } else {
      setFormData((preData) => ({
        ...preData,
        satelliteStores: _.map(preData.wardIds, (item) => ({
          adsLocation: '',
          categorySatelliteStoresId: 0,
          satelliteStoresAlertThreshold: 0,
          satelliteStoresName: '',
          thresholdSettingsDay: 1,
          wardId: item.value,
          satelliteBoundDevice: false,
          id: getUUID(),
        })),
        loanModel: value,
      }));
    }
  };

  // 表单的Change事件
  const formChangeHandler = useCallback(
    (type) => {
      return (value) => {
        if (type === 'wardIds' && _.isArray(value)) {
          changeWardIds(value);
          return;
        }
        if (type === 'loanModel') {
          changeLoanModel(value);
          return;
        }
        setFormData((preData) => ({ ...preData, [type]: value }));
      };
    },
    [wardsOptions]
  );
  const adsChangeHandler = useCallback((type) => {
    return (value) => {
      setAdsInfo((preData) => ({ ...preData, [type]: value }));
    };
  }, []);
  useEffect(() => {
    (async () => {
      await getWardList();
    })();
    (async () => {
      await euipmentMasterCategoryList();
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await getAdsServiceTypeApi();
    })();
  }, [getAdsServiceTypeApi]);

  // 提交验证表单apis
  const createEqCategory = useCallback(async () => {
    try {
      const mainWardIds = formData.mainWardIds ? [formData.mainWardIds] : [];
      const newRecipients = _.map(formData?.recipients, (recipientItem) => ({
        categoryRecipientsId: recipientItem?.isNew ? 0 : recipientItem?.categoryRecipientsId,
        recipients: recipientItem?.recipients,
        recipientsType: recipientItem?.recipientsType,
      }));
      // 同步 wardThreshold 与 satelliteStores里面有的 wardId
      const satelliteStoreWardIds = _.uniqBy(_.map(formData?.satelliteStores, (item) => item.wardId));
      const centralStoreWardIds = _.map(formData?.wardIds, (item) => item?.value);
      const alignWardIds = formData?.loanModel === 1 ? centralStoreWardIds : satelliteStoreWardIds;

      let params = {
        hospitalId: loginInfo.hospitalId,
        masterCategoryId: formData.masterCategoryId,
        criticalCategory: formData.criticality,
        loanModel: formData.loanModel,
        wardIds:
          formData.loanModel === 1
            ? _.map(formData.wardIds, (item) => item.value)
            : _.map(formData.satelliteStores, (item) => item.wardId),
        mainWardIds: formData.loanModel === 1 ? mainWardIds : null,
        isCheck: formData.checkboxState ? 1 : -1,
        adsInfo: formData.checkboxADSIntergration ? adsInfo : null,
        isReceiptConfirmation: formData.isReceiptConfirmation,
        isWardTransfer: formData.isWardTransfer,
        satelliteStores: formData.loanModel === 2 ? formData.satelliteStores : [],
        isPatientNo: formData.isPatientNo,
        loanDurationEnableYn: loanDuration.loanDurationEnableYn ? 'Y' : 'N',
        loanDuration: Number(loanDuration.loanDuration),
        returnType: formData.returnType,
        returnDesignateLocation: formData.returnDesignateLocation,
        returnDesignateRoom: formData.returnDesignateRoom,
        emailAlertEnableYn: formData.emailAlertEnableYn ? 'Y' : 'N',
        recipients: newRecipients,
        wardThreshold: alignWardThresholdWithWardIds(formData?.wardThreshold, alignWardIds),
      };
      await systemAPI.addEquipmentCategory(params);
      dialogFinishHandler();
    } catch (error) {
      console.log(error);
    }
  }, [formData, dialogFinishHandler, adsInfo, loanDuration]);

  // 提交表單事件
  const dialogOpenHandler = useCallback(() => {
    (async () => {
      await createEqCategory();
    })();
  }, [createEqCategory]);
  // checkbox
  const checkChange = (name) => {
    return (event) => {
      if (name === 'isReceiptConfirmation' || name === 'isWardTransfer' || name === 'isPatientNo') {
        setFormData({ ...formData, [name]: event.target.checked ? 1 : 0 });
      } else {
        setFormData({ ...formData, [name]: event.target.checked });
      }
    };
  };
  const adsCheckChange = (name) => {
    return (event) => {
      setAdsInfo((prevInfo) => ({
        ...prevInfo,
        [name]: event.target.checked ? 1 : 0,
        adsCreationTigger: name === 'adsBorrowEnableYn' ? (event.target.checked ? 1 : 0) : prevInfo.adsCreationTigger,
      }));
    };
  };

  const returnOrderTypecheckChange = (data) => {
    return (event) => {
      if (data.isShowInput) {
        setThresholdSettingsReadOnly(false);
      } else {
        setThresholdSettingsReadOnly(true);
      }
      setReturnOrderTypeList(
        _.map(returnOrderTypeList, (item, index) => {
          return { ...item, checked: item.id === data.id };
        })
      );
      setAdsInfo({ ...adsInfo, adsReturnOrderType: data.id });
    };
  };

  const radioHandleChange = (data) => (event) => {
    setBorrowOrderTypeList(
      _.map(borrowOrderTypeList, (item, index) => {
        return { ...item, checked: item.id === data.id };
      })
    );
    setAdsInfo({ ...adsInfo, adsBorrowOrderType: data.id });
  };

  // 如果勾选了 Enable Return ADS Order，则需要检查 loanDuration 是否符合要求
  const loanDurationError = useMemo(() => {
    if (loanDuration.loanDurationEnableYn) {
      const pattern = /^(36[0-5]|3[0-5][0-9]|[12][0-9][0-9]|[1-9][0-9]?)$/;
      return !pattern.test(loanDuration.loanDuration);
    } else {
      return false;
    }
  }, [loanDuration]);

  const confirmDisabled = useMemo(() => {
    if (formData.checkboxADSIntergration) {
      return (
        !adsInfo.adsBorrowServiceType ||
        !adsInfo.adsReturnServiceType ||
        !adsInfo.adsBorrowOrderType ||
        (thresholdSettingsReadOnly ? !adsInfo.adsReturnOrderType : !adsInfo.adsReturnThresholdSettings) ||
        !formData.masterCategoryId ||
        (formData.returnType === 2 && (!formData.returnDesignateRoom || !formData.returnDesignateLocation)) ||
        loanDurationError
      );
    } else {
      return !formData.masterCategoryId || loanDurationError;
    }
  }, [
    formData.masterCategoryId,
    adsInfo.adsBorrowServiceType,
    adsInfo.adsReturnServiceType,
    formData.checkboxADSIntergration,
    adsInfo.adsBorrowOrderType,
    adsInfo.adsReturnOrderType,
    adsInfo.adsReturnThresholdSettings,
    thresholdSettingsReadOnly,
    formData.returnDesignateRoom,
    formData.returnDesignateLocation,
    satelliteStores,
    formData.checkboxADSIntergration,
    formData.returnType,
    loanDurationError,
  ]);

  const disabledCheckboxList = satelliteStores && satelliteStoresTotal === 0;

  // 更新 Enable Return ADS Order 的时候清空它的子选项
  useUpdateEffect(() => {
    setFormData((prevInfo) => ({
      ...prevInfo,
      returnDesignateRoom: '',
      returnDesignateLocation: '',
    }));
  }, [formData.returnType]);

  return (
    <DiaLog
      open={true}
      handleClose={dialogCloseHandler}
      handleCancel={dialogCloseHandler}
      handleConfirm={dialogOpenHandler}
      title={i18n.t('SETTING_ADD_EQUIPMENT_CATEGORY')}
      cancel={i18n.t('SETTING_CANCEL')}
      confirm={i18n.t('SETTING_SAVE')}
      dialogfootStyle={{ marginTop: '1rem' }}
      id="setting-new-equiment-dialog"
      disabled={confirmDisabled}
      width="auto"
      p="1.5rem"
    >
      <Box display="flex" width="100%" gridGap="1.5rem">
        <Box width="40.5rem">
          <Box display="flex" marginBottom="0.5rem" gridGap="0.63rem">
            <Box flexBasis="50%">
              <div className={classes.title}>
                {i18n.t('SETTING_EQUIPMENT_CATEGORY')}
                <span className={classes.colorRed}> *</span>
              </div>
              <AutoCompleteSelect
                className={classes.wardAutoSelect}
                id="setting-add-equipment-category"
                height="3.5rem"
                itemList={categoryList}
                placeholder={i18n.t('SETTING_ENTER_EQUIPMENT_CATEGORY')}
                value={formData.masterCategoryId}
                onChange={formChangeHandler('masterCategoryId')}
              />
            </Box>
            <Box flexBasis="50%">
              <div className={classes.title}>{i18n.t('SETTING_CATEGORY')}</div>
              <AutoCompleteSelect
                className={classes.wardAutoSelect}
                id="setting-add-criticality"
                height="3.5rem"
                itemList={criticalCategoryList}
                placeholder="Select Critical Category"
                value={formData.criticality}
                onChange={formChangeHandler('criticality')}
              />
            </Box>
          </Box>
          <Box marginBottom="0.5rem">
            <Box fontSize="1.125rem" fontWeight="bold" color="#2E4469" paddingBottom="1.063rem" paddingTop="1.063rem">
              {i18n.t('SETTING_LOAN_MODEL')}
            </Box>
            <Box paddingBottom="1.5rem">
              <div className={classes.title}>{i18n.t('SETTING_LOAN_MODEL')}</div>
              <AutoCompleteSelect
                height="3.5rem"
                itemList={LOAN_MODEL_OPTIONS}
                value={formData.loanModel}
                onChange={formChangeHandler('loanModel')}
                id="setting-select-loan-model"
              />
            </Box>
            {centralStore && (
              <Box paddingBottom="1.5rem">
                <div className={classes.title}>{i18n.t('SETTING_CENTRAL_STORE')}</div>
                <AutoCompleteMultiCheckbox
                  className={classes.wardAutoSelect}
                  dropDownIcon={true}
                  align="right"
                  height="3.5rem"
                  errMsgMargin="3px 0 0 0.825rem"
                  errMsgWidth="11rem"
                  allText={i18n.t('SETTING_ALL_CENTRAL_STORE')}
                  itemList={wardsOptions}
                  value={formData.wardIds}
                  onChange={formChangeHandler('wardIds')}
                  id="setting-add-loan-model"
                  placeholder={i18n.t('SETTING_SELECT_FROM_BELOW')}
                  showAllText={true}
                  fixation={true}
                />
              </Box>
            )}
            {centralStore && showMainStore && (
              <Box paddingBottom="1.5rem">
                <div className={classes.title}>{i18n.t('SETTING_MAIN_STORE')}</div>
                <AutoCompleteSelect
                  className={classes.wardAutoSelect}
                  id="setting-add-main-store"
                  height="3.5rem"
                  itemList={mainStoreList}
                  placeholder={i18n.t('SETTING_SELECT_FROM_BELOW')}
                  value={formData.mainWardIds}
                  onChange={formChangeHandler('mainWardIds')}
                />
              </Box>
            )}
            {satelliteStores && (
              <Box pb="1.25rem" borderBottom="solid 1px #E6E7E8" marginBottom="1.5rem">
                <Box display="flex" justifyContent="space-between" alignItems="center" pr="1.25rem">
                  <Text color="#2e4469" fontSize="1.25rem" fontWeight="700">
                    Satellite Store List
                  </Text>
                  <ButtonBase onClick={() => setSatelliteStorePopup(true)}>
                    <Text fontSize="1rem" color="#538FFF" fontWeight="700">
                      Edit List ({satelliteStoresTotal})
                    </Text>
                    <DropRightIcon style={{ fontSize: '0.625rem', color: '#538FFF', marginLeft: '1rem' }} />
                  </ButtonBase>
                </Box>
              </Box>
            )}
            <CentralStoreEmailAlert
              formData={formData}
              setRecipientsListPopup={setRecipientsListPopup}
              checkChange={checkChange}
              setCentralStoreThresholdPopup={setCentralStoreThresholdPopup}
            />
            <Box display="flex" flexDirection="column">
              <FormControlLabel
                control={<Checkbox />}
                label={i18n.t('SETTING_EQUIPMENT_LOAN_DURATION')}
                checked={loanDuration.loanDurationEnableYn}
                onChange={(e) =>
                  setLoanDuration((prevData) => ({
                    ...prevData,
                    loanDurationEnableYn: e.target.checked,
                  }))
                }
                className={classes.checkBox}
              />
              <StyleInput
                inputProps={{ type: 'number' }}
                value={loanDuration.loanDuration}
                onChange={(value) =>
                  setLoanDuration((prevData) => ({
                    ...prevData,
                    loanDuration: value,
                  }))
                }
                placeholder="Number of day(s) (Integer)"
                error={loanDurationError}
              />
              {loanDurationError && <Text color="#f44336">Invalid value for long loan duration.</Text>}
            </Box>
            <Box>
              <FormControlLabel
                id="setting_add_equipment_checkbox4"
                control={<Checkbox />}
                label={i18n.t('SETTING_EQUIPMENT_ENFORCE_MANDATORY_PATIENT_HN_NUMBER_IN_LOAN_REQUEST_CREATION')}
                className={classes.checkBox}
                checked={Boolean(formData.isPatientNo)}
                onChange={checkChange('isPatientNo')}
                disabled={disabledCheckboxList}
              />
            </Box>
            <Box>
              <FormControlLabel
                id="setting_add_equipment_checkbox1"
                control={<Checkbox />}
                label={i18n.t('SETTING_CHECKBOX_REQUEST')}
                className={classes.checkBox}
                checked={Boolean(formData.checkboxState)}
                onChange={checkChange('checkboxState')}
                disabled={disabledCheckboxList}
              />
            </Box>
            <Box>
              <FormControlLabel
                id="setting_add_equipment_checkbox2"
                control={<Checkbox />}
                label={i18n.t('SETTING_EQUIPMENT_CHECKBOX')}
                className={classes.checkBox}
                checked={Boolean(formData.isReceiptConfirmation)}
                onChange={checkChange('isReceiptConfirmation')}
                disabled={disabledCheckboxList}
              />
            </Box>
            <Box>
              <FormControlLabel
                id="setting_add_equipment_checkbox3"
                control={<Checkbox />}
                label={i18n.t('SETTING_EQUIPMENT_ALLOW_TRANSFER')}
                className={classes.checkBox}
                checked={Boolean(formData.isWardTransfer)}
                onChange={checkChange('isWardTransfer')}
                disabled={disabledCheckboxList}
              />
            </Box>
            <Box>
              <FormControlLabel
                id="setting_add_equipment_ADS"
                control={<Checkbox />}
                label={i18n.t('SETTING_EQUIPMENT_ENABLE_ADS')}
                className={classes.checkBox}
                checked={Boolean(formData.checkboxADSIntergration)}
                onChange={checkChange('checkboxADSIntergration')}
                disabled={disabledCheckboxList}
              />
            </Box>
            <Box paddingTop="1rem" borderTop="1px solid rgb(230, 231, 232)">
              <Text color="#2e4469" fontSize="1.25rem" fontWeight="700">
                {i18n.t('SETTING_RETURN_TYPE')}
              </Text>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              mt="0.5rem"
              p="0.25rem 1.25rem"
              borderRadius="0.9375rem"
              bgcolor="#F5FAFF"
            >
              <FormControlLabel
                control={<Radio />}
                label={i18n.t('SETTING_RETURN_TO_CENTRAL_STORE_PROVIDER')}
                className={classes.checkBox}
                checked={formData.returnType === 1}
                onChange={() => {
                  setFormData((prevInfo) => ({
                    ...prevInfo,
                    returnType: prevInfo.returnType === 1 ? 0 : 1,
                  }));
                }}
              />
              {satelliteStores && (
                <FormControlLabel
                  control={<Radio />}
                  label={i18n.t('SETTING_RETURN_TO_SATELLITE_STORE_PROVIDER')}
                  className={classes.checkBox}
                  checked={formData.returnType === 2}
                  onChange={() => {
                    setFormData((prevInfo) => ({
                      ...prevInfo,
                      returnType: prevInfo.returnType === 2 ? 0 : 2,
                    }));
                  }}
                />
              )}
              <FormControlLabel
                control={<Radio />}
                label={i18n.t('SETTING_RETURN_TO_DESIGNATE_RETURN_LOCATION_ADS')}
                className={classes.checkBox}
                checked={formData.returnType === 3}
                onChange={() => {
                  setFormData((prevInfo) => ({
                    ...prevInfo,
                    returnType: prevInfo.returnType === 3 ? 0 : 3,
                  }));
                }}
              />
              {formData.returnType === 3 && (
                <Box>
                  <Box mt="0.5rem" mb="1.25rem">
                    <div className={classes.title}>
                      {i18n.t('SETTING_EQUIPMENT_LOCATION_NAME')}
                      <span className={classes.colorRed}> *</span>
                    </div>
                    <StyleInput
                      width="100%"
                      height="3.5rem"
                      placeholder="Text here"
                      value={formData.returnDesignateRoom}
                      onChange={formChangeHandler('returnDesignateRoom')}
                    />
                  </Box>
                  <Box>
                    <div className={classes.title}>
                      {i18n.t('SETTING_EQUIPMENT_ADS_LOCATION_NAME')}
                      <span className={classes.colorRed}> *</span>
                    </div>
                    <AutoCompleteSelect
                      className={classes.wardAutoSelect}
                      height="3.5rem"
                      itemList={adsItemList}
                      placeholder="Text here"
                      value={formData.returnDesignateLocation}
                      onChange={formChangeHandler('returnDesignateLocation')}
                    />
                  </Box>
                </Box>
              )}
            </Box>
            {centralStore && formData.checkboxADSIntergration && (
              <Box>
                <Box marginBottom="0.5rem">
                  <Box
                    fontSize="1.125rem"
                    fontWeight="bold"
                    color="#3e3e3e"
                    paddingBottom="1.063rem"
                    paddingTop="1.063rem"
                  >
                    {i18n.t('SETTING_EQUIPMENT_ADS_SERVICE_TYPE')}
                  </Box>
                  <Box paddingBottom="1.5rem">
                    <div className={classes.title}>
                      {i18n.t('SETTING_EQUIPMENT_BORROW_SERVICE_TYPE')}
                      <span className={classes.colorRed}> *</span>
                    </div>
                    <AutoCompleteSelect
                      className={classes.wardAutoSelect}
                      id="setting-add-equipment-borrow-service-type"
                      height="3.5rem"
                      itemList={aDSServiceTypeListOptions}
                      placeholder={i18n.t('SETTING_EQUIPMENT_BORROW_SERVICE_TYPE_PLACEHOLDER')}
                      value={adsInfo.adsBorrowServiceType}
                      onChange={adsChangeHandler('adsBorrowServiceType')}
                    />
                  </Box>
                  <Box paddingBottom="1.5rem">
                    <div className={classes.title}>
                      {i18n.t('SETTING_EQUIPMENT_RETURN_SERVICE_TYPE')}
                      <span className={classes.colorRed}> *</span>
                    </div>
                    <AutoCompleteSelect
                      className={classes.wardAutoSelect}
                      id="setting-add-equipment-return-service-type"
                      height="3.5rem"
                      itemList={aDSServiceTypeListOptions}
                      placeholder={i18n.t('SETTING_EQUIPMENT_RETURN_SERVICE_TYPE_PLACEHOLDER')}
                      value={adsInfo.adsReturnServiceType}
                      onChange={adsChangeHandler('adsReturnServiceType')}
                    />
                  </Box>
                </Box>
                <Box>
                  <Box fontSize="1.125rem" fontWeight="bold" color="#3e3e3e" paddingBottom="1.063rem">
                    {i18n.t('SETTING_EQUIPMENT_ADS_ORDER_TYPE')}
                  </Box>
                  <Box paddingBottom="1.5rem">
                    <div className={classes.title}>
                      {i18n.t('SETTING_EQUIPMENT_BORROW_ORDER_TYPE')}
                      <span className={classes.colorRed}> *</span>
                    </div>
                    <Box display="flex">
                      {_.map(borrowOrderTypeList, (item, index) => {
                        return (
                          <Box display="flex" alignItems="center" key={index} className={classes.radioLabel}>
                            <FormControlLabel
                              control={
                                <Radio
                                  checked={Boolean(item?.checked)}
                                  onChange={radioHandleChange(item)}
                                  color="primary"
                                  className={classes.radio}
                                />
                              }
                              label={item?.label}
                              className={classes.returnOrderTypeCheckBox}
                            />
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                  <Box mb="1rem">
                    <div className={classes.title}>
                      {i18n.t('SETTING_EQUIPMENT_RETURN_ORDER_TYPE')}
                      <span className={classes.colorRed}> *</span>
                    </div>

                    <Box>
                      {_.map(returnOrderTypeList, (item, index) => {
                        return (
                          <Box display="flex" alignItems="center" key={index}>
                            <FormControlLabel
                              control={
                                <Radio
                                  checked={Boolean(item?.checked)}
                                  onChange={returnOrderTypecheckChange(item)}
                                  color="primary"
                                />
                              }
                              label={item?.label}
                              className={classes.returnOrderTypeCheckBox}
                            />
                            {item?.isShowInput && (
                              <>
                                <LongRemark content={i18n.t('SETTING_EQUIPMENT_THRESHOLD_REMARK')} />
                                <Counter
                                  width="18.625rem"
                                  value={adsInfo.adsReturnThresholdSettings}
                                  onChange={adsChangeHandler('adsReturnThresholdSettings')}
                                  style={{ marginLeft: '2rem' }}
                                  inputBaseReadOnly={thresholdSettingsReadOnly}
                                />
                              </>
                            )}
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
            {satelliteStores && formData.checkboxADSIntergration && (
              <Box pt="1.25rem" borderTop="solid 1px #E6E7E8" marginTop="1.25rem">
                <Box fontSize="1.125rem" fontWeight="bold" color="#2e4469" paddingBottom="1.063rem">
                  {i18n.t('SETTING_EQUIPMENT_ADS_ORDER_TYPE')}
                </Box>
                <Box display="flex">
                  <Box flexBasis="50%">
                    <div className={classes.title} style={{ color: '#666666' }}>
                      {i18n.t('SETTING_EQUIPMENT_BORROW_ORDER_TYPE')}
                      <span className={classes.colorRed}> *</span>
                    </div>
                    <Box display="flex" flexDirection="column">
                      {_.map(borrowOrderTypeList, (item, index) => {
                        return (
                          <Box display="flex" alignItems="center" key={index} className={classes.radioLabel}>
                            <FormControlLabel
                              control={
                                <Radio
                                  checked={Boolean(item?.checked)}
                                  onChange={radioHandleChange(item)}
                                  color="primary"
                                  className={classes.radio}
                                />
                              }
                              label={item?.label}
                              className={classes.returnOrderTypeCheckBox}
                            />
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                  <Box flexBasis="50%">
                    <div className={classes.title} style={{ color: '#666666' }}>
                      {i18n.t('SETTING_EQUIPMENT_RETURN_ORDER_TYPE')}
                      <span className={classes.colorRed}> *</span>
                    </div>

                    <Box>
                      {_.map(returnOrderTypeList, (item, index) => {
                        return (
                          <Box display="flex" alignItems="center" key={index}>
                            <FormControlLabel
                              control={
                                <Radio
                                  checked={Boolean(item?.checked)}
                                  onChange={returnOrderTypecheckChange(item)}
                                  color="primary"
                                />
                              }
                              label={item?.label}
                              className={classes.returnOrderTypeCheckBox}
                            />
                            {item?.isShowInput && <LongRemark content={i18n.t('SETTING_EQUIPMENT_THRESHOLD_REMARK')} />}
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
        {satelliteStores && formData.checkboxADSIntergration && (
          <>
            <Box minWidth="1px" bgcolor="#E6E7E8" />
            <Box width="40.5rem">
              <Box>
                <Box marginBottom="0.5rem">
                  <Box fontSize="1.125rem" fontWeight="bold" color="#2E4469" paddingBottom="1.063rem">
                    {i18n.t('SETTING_EQUIPMENT_ADS_SERVICE_TYPE')}
                  </Box>
                  <Box paddingBottom="1rem">
                    <div className={classes.title} style={{ color: '#666666' }}>
                      {i18n.t('SETTING_EQUIPMENT_BORROW_SERVICE_TYPE')}
                      <span className={classes.colorRed}> *</span>
                    </div>
                    <AutoCompleteSelect
                      className={classes.wardAutoSelect}
                      height="3.5rem"
                      itemList={aDSServiceTypeListOptions}
                      placeholder={i18n.t('SETTING_EQUIPMENT_RETURN_SERVICE_TYPE_PLACEHOLDER')}
                      value={adsInfo.adsBorrowServiceType}
                      onChange={adsChangeHandler('adsBorrowServiceType')}
                    />
                    <Box>
                      <FormControlLabel
                        control={<Checkbox />}
                        label={i18n.t('SETTING_EQUIPMENT_ENABLE_BORROW_ADS_ORDER')}
                        className={classes.checkBox}
                        checked={Boolean(adsInfo.adsBorrowEnableYn)}
                        onChange={adsCheckChange('adsBorrowEnableYn')}
                      />
                    </Box>
                    {Boolean(adsInfo.adsBorrowEnableYn) && (
                      <Box display="flex" flexDirection="column">
                        <Text color="#2e4469" fontSize="1.25rem" fontWeight="700">
                          {i18n.t('SETTING_EQUIPMENT_ADS_ORDER_CREATION_TIGGER_POINT')}
                        </Text>
                        <FormControlLabel
                          control={<Checkbox />}
                          label={i18n.t('SETTING_EQUIPMENT_WHEN_LOAN_REQUEST_IS_CREATED')}
                          className={classes.checkBox}
                          checked={adsInfo.adsCreationTigger === 1}
                          onChange={() =>
                            setAdsInfo((prevInfo) => ({
                              ...prevInfo,
                              adsCreationTigger: 1,
                            }))
                          }
                        />
                        <FormControlLabel
                          control={<Checkbox />}
                          label={i18n.t('SETTING_EQUIPMENT_WHEN_EQUIPMENT_IS_ASSIGNED')}
                          className={classes.checkBox}
                          checked={adsInfo.adsCreationTigger === 2}
                          onChange={() =>
                            setAdsInfo((prevInfo) => ({
                              ...prevInfo,
                              adsCreationTigger: 2,
                            }))
                          }
                        />
                      </Box>
                    )}
                  </Box>
                  <Box paddingBottom="1rem">
                    <div className={classes.title} style={{ color: '#666666' }}>
                      {i18n.t('SETTING_EQUIPMENT_RETURN_SERVICE_TYPE')}
                      <span className={classes.colorRed}> *</span>
                    </div>
                    <AutoCompleteSelect
                      className={classes.wardAutoSelect}
                      height="3.5rem"
                      itemList={aDSServiceTypeListOptions}
                      placeholder={i18n.t('SETTING_EQUIPMENT_RETURN_SERVICE_TYPE_PLACEHOLDER')}
                      value={adsInfo.adsReturnServiceType}
                      onChange={adsChangeHandler('adsReturnServiceType')}
                    />
                    <Box>
                      <FormControlLabel
                        control={<Checkbox />}
                        label={i18n.t('SETTING_ENABLE_RETURN_ADS_ORDER')}
                        className={classes.checkBox}
                        checked={Boolean(adsInfo.adsReturnEnableYn)}
                        onChange={adsCheckChange('adsReturnEnableYn')}
                      />
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <div className={classes.title} style={{ color: '#666666' }}>
                    {i18n.t('SETTING_INTER_SATELLITE_STORE_TRANSFER_SERVICE_TYPE')}
                  </div>
                  <AutoCompleteSelect
                    className={classes.wardAutoSelect}
                    height="3.5rem"
                    itemList={aDSServiceTypeListOptions}
                    placeholder={i18n.t('SETTING_EQUIPMENT_RETURN_SERVICE_TYPE_PLACEHOLDER')}
                    value={adsInfo.satelliteStoresTransferServiceType}
                    onChange={adsChangeHandler('satelliteStoresTransferServiceType')}
                  />
                  <Box>
                    <FormControlLabel
                      control={<Checkbox />}
                      label={i18n.t('SETTING_ENABLE_INTER_SATELLITE_STORE_TRANSFER_ADS_ORDER')}
                      className={classes.checkBox}
                      checked={Boolean(adsInfo.satelliteStoresTransferEnableYn)}
                      onChange={adsCheckChange('satelliteStoresTransferEnableYn')}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </>
        )}
      </Box>
      {recipientsListPopup && (
        <RecipientsListPopup
          recipients={formData?.recipients}
          handleClose={() => setRecipientsListPopup(false)}
          handleSubmit={(recipientsList) => setFormData({ ...formData, recipients: recipientsList })}
        />
      )}
      {satelliteStorePopup && (
        <SatelliteStorePopup
          data={formData}
          thresholdSettingsReadOnly={thresholdSettingsReadOnly}
          handleClose={() => setSatelliteStorePopup(false)}
          handleUpdate={formChangeHandler('satelliteStores')}
          wardsOptions={wardsOptions}
        />
      )}
      {centralStoreThresholdPopup && (
        <CentralStoreThresholdPopup
          handleClose={() => setCentralStoreThresholdPopup(false)}
          setRecipientsListPopup={setRecipientsListPopup}
          checkChange={checkChange}
          formData={formData}
          wardsOptions={wardsOptions}
          formChangeHandler={formChangeHandler}
        />
      )}
    </DiaLog>
  );
};

export const LOAN_MODEL_OPTIONS = [
  {
    text: 'Central Store only',
    value: 1,
  },
  {
    text: 'Central Store with Satellite store',
    value: 2,
  },
];

export default EquipmentCategoryDialog;
